// src/shared-components/cards/components/CategorySliderCard.jsx
import ArtworkImage from "@/shared-components/cards/components/ArtworkImage"; 
import Text from "@/shared-components/text/components/Text";

import "./styles/CategorySliderCard.css";

const clampPercent = (value) => Math.max(0, Math.min(100, value));

function normalizeCrop(rawCrop) {
  if (!rawCrop || typeof rawCrop !== "object" || Array.isArray(rawCrop)) {
    return null;
  }

  const xRaw = Number(rawCrop.x);
  const yRaw = Number(rawCrop.y);
  const widthRaw = Number(rawCrop.width);
  const heightRaw = Number(rawCrop.height);

  if (
    !Number.isFinite(xRaw) ||
    !Number.isFinite(yRaw) ||
    !Number.isFinite(widthRaw) ||
    !Number.isFinite(heightRaw) ||
    widthRaw <= 0 ||
    heightRaw <= 0
  ) {
    return null;
  }

  const width = clampPercent(widthRaw);
  const height = clampPercent(heightRaw);
  if (!width || !height) {
    return null;
  }

  const maxX = Math.max(0, 100 - width);
  const maxY = Math.max(0, 100 - height);

  return {
    x: Math.min(maxX, clampPercent(xRaw)),
    y: Math.min(maxY, clampPercent(yRaw)),
    width,
    height,
  };
}

function resolveCoverCrop(category, imageId) {
  if (!imageId) return null;

  const displayCover = category?.displayCover || null;
  const directCoverCrop =
    displayCover && displayCover === imageId ? category?.coverCrop : null;
  const directRandomCoverCrop =
    category?.randomCover && category.randomCover === imageId
      ? category?.randomCoverCrop
      : null;
  const directImageCrop =
    category?.image && category.image === imageId ? category?.imageCrop : null;
  const metadataCrop = category?.metadata?.pool_crops?.[imageId];

  return (
    normalizeCrop(directCoverCrop) ||
    normalizeCrop(directRandomCoverCrop) ||
    normalizeCrop(directImageCrop) ||
    normalizeCrop(metadataCrop)
  );
}

export default function CategorySliderCard({ category }) {
  // category = { image, slug, subcat, name, cta? }
  // Usaremos `image` para mostrar la miniatura, y `subcat` o `name` como texto visible.

  const covers = Array.isArray(category.covers) ? category.covers : [];
  const pickedCover = category.displayCover || category.randomCover || covers[0];
  const imageId = pickedCover || category.image;
  const label   = category.name;
  // Ratio 3:2 como ejemplo:
  const aspectRatio = 3 / 2;
  const crop = resolveCoverCrop(category, imageId);
  const cropCenterX = crop ? clampPercent(crop.x + crop.width / 2) : null;
  const cropCenterY = crop ? clampPercent(crop.y + crop.height / 2) : null;
  const imageStyle = crop
    ? {
      aspectRatio,
      objectPosition: `${cropCenterX}% ${cropCenterY}%`,
    }
    : { aspectRatio };

  return (
    <div className="category-card__container">
      <div className="category-card__image-wrapper">
        {imageId ? (
          <ArtworkImage
            image={imageId}
            imageClassName="category-card__image"
            imageTemplateClassName="category-card__image"
            style={imageStyle}
          />
        ) : (
          <div className="category-card__no-image">No image</div>
        )}
      </div>
      <div className="category-card__caption">
        <Text className="category-card__label">{label}</Text>
      </div>
    </div>
  );
}
